import { GlobalVariables } from "../GlobalVariables";

export default class HashScroll {
    static init() {
        let hash = window.location.hash;

        setTimeout(() => {
            this.scrollToHash(hash);
        }, 500);

    }

    static scrollToHash(hash) {
        let headerMain = document.querySelector(".header-main");
        let headerMainHeight = headerMain.offsetHeight;

        if (hash) {
            GlobalVariables.smoother.scrollTo(hash, true, `top ${headerMainHeight}`);
        }
    }
}